<div mat-dialog-content>
  <lemon-dialog-header>{{ 'app.vaihda-yritys-dialog.otsikko' | translate | async }}</lemon-dialog-header>

  <div class="nykyinen-otsikko">{{ 'app.vaihda-yritys-dialog.nykyinen' | translate | async }}</div>
  <div class="yritys nykyinen">
    <div class="yritys-nimi">{{ data.nykyinenYritys.asiakasNimi }}</div>
    <div class="yritys-ytunnus">{{ data.nykyinenYritys.ytunnus }}</div>
  </div>

  @for (yritys of data.vaihdettavatYritykset; track yritys.kayttajaAvain) {
    <button type="button" class="yritys vaihdettava" [disabled]="vaihdetaan()" (click)="vaihda(yritys)">
      <div class="yritys-nimi">{{ yritys.asiakasNimi }}</div>
      <div class="yritys-ytunnus">{{ yritys.ytunnus }}</div>
    </button>
  }

  @if (virhe()) {
    <mat-error>{{ virhe() }}</mat-error>
  }
</div>
<div mat-dialog-actions>
  <button class="primarybutton" mat-button mat-dialog-close [disabled]="vaihdetaan()">{{ 'yleiset.peruuta' | translate | async }}</button>
</div>
